const compactNumberFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1,
});

export const formatCompactTokenCount = (value: number | null | undefined) => {
  if (value === null || value === undefined) {
    return '-';
  }

  return compactNumberFormatter.format(value);
};

export const formatTokenCountLabel = (value: number | null | undefined) => {
  return `${formatCompactTokenCount(value)} tokens`;
};
